import  ApiService  from '../../services/api.service'
import HashMake from '../../services/hash.service'
import { TokenService } from '../../services/storage.service';



const state =  {
    cartProducts: [],
    currentProduct: {},
    loading: false,
    qtyLoading: false,
    showPopupCart: false,
    showModal: false,
    userDetails: TokenService.getUserDetails(),
    cartId: null,
    otherInfo: [],
    cartDetails: [],
    additionalServices: [],
    servicesLoading: false,
    shippingChargeDetails:[],
    rimSizes: [],
    promocode: null,
    promoLoading: false,
    promocodeErrors: [],
    cartShippingAddressType: ''
}

const getters = {
    loading: state => state.loading,
    qtyLoading: state => state.qtyLoading,
    cartProducts: state => state.cartProducts,
    getCurrentProduct: state => state.currentProduct,
    getShowModal: state => state.showModal,
    getPopupCart: state => state.showPopupCart,
    cartId: state => state.cartId,
    cartDetails: state => state.cartDetails,
    additionalServices: state => state.additionalServices,
    servicesLoading: state => state.servicesLoading,
    rimSizes: (state) => state.rimSizes,
    shippingChargeDetails: (state) => state.shippingChargeDetails,
    promocode: (state) => state.promocode,
    promoLoading: (state) => state.promoLoading,
    promocodeErrors: (state) => state.promocodeErrors,
    cartShippingAddressType: (state) => state.cartShippingAddressType,
}
const mutations = {
    setProduct(state, product) {
        state.cartProducts.push(product);
    },
    setCartProducts(state, products) {
        state.cartProducts = products;
    },
    removeProduct(state, index) {
        state.cartProducts.splice(index, 1);
    },
    currentProduct(state, product) {
        state.currentProduct = product;
    },
    updateProductQuantity(state, data) {
        state.cartProducts = state.cartProducts.map(cartProduct => (
            cartProduct.name === data.name
              ? data
              : cartProduct
          ))
    },
    updateProduct(state, data) {
        state.cartProducts = state.cartProducts.map(cartProduct => (
            cartProduct.name === data.name
              ? data
              : cartProduct
          ))
    },
    SHOW_MODAL(state) {
        state.showModal = !state.showModal;
    },
    SHOW_POPUP_CART(state) {
        state.showPopupCart = !state.showPopupCart;
    },
    setLoading(state, value) {
        state.loading = value;
    },
    qtyLoading(state, value) {
        state.qtyLoading = value;
    },
    setCartId(state, cartId) {
        state.cartId = cartId
    },
    setCartDetails(state, data) {
        state.cartDetails = data
    },
    setAdditionalServices(state, services) {
        state.additionalServices = services
    },
    setServicesLoading(state, status) {
        state.servicesLoading = status
    },
    setRimSizes(state, lists) {
        state.rimSizes = JSON.parse(JSON.stringify(_.compact(lists)))
    },
    removeProductRimSize(state, productId) {
        state.rimSizes = _.remove(state.rimSizes, function(n) {
            let rim = n.split(":")
            return rim[0]!=productId
        })
    },
    setPromocode(state, value) {
        state.promocode = value
    },
    setPromoLoading(state, value) {
        state.promoLoading = value
    },
    setPromocodeErrors(state, details) {
        state.promocodeErrors = details
    },
    resetErrors(state) {
        state.promocodeErrors = []
    },
    setCartShippingAddressType(state, value) {
        state.cartShippingAddressType = value
    },
}
const actions = {
    loginMergeCartProducts({commit}) {
        commit('setLoading', true)
        let token = TokenService.getToken()
        if(token && TokenService.getGuestToken()) {
            let formdata = new FormData()
            let anonymousId = TokenService.getGuestToken()
            formdata.append('anonymous_id', anonymousId)
            return new Promise((resolve, reject) => {
                ApiService.post('/customer/cart/merge', formdata,
                { 'headers': { 'token': token} })
                    .then(response => {
                        const products = []
                        if(response.data && response.data.id) {
                            commit('setCartId', response.data.id)
                        } else {
                            commit('setCartId', null)
                        }
                        if(response.data 
                            && response.data.line_items 
                            && response.data.line_items.length > 0) {
                            _.forEach(response.data.line_items, function(value) {
                                if(value.type==="product") {
                                    products.push({
                                        'cart_id':value.cart_id,
                                        'id':value.id,
                                        'type_id':value.type_id,
                                        'name':value.product.name,
                                        'brand_name':value.product.brand_name,
                                        'image': (value.product.images && value.product.images.length != 0 && value.product.images != null) ? value.product.images[0].image_base_path+value.product.images[0].path:'/images/no-data-found.png',
                                        'brand_image':(value.product.brand && value.product.brand.length != 0 && value.product.brand.image_path != null) ? value.product.brand.image_base_path+value.product.brand.image_path:'/images/nologo.png',
                                        'net_price': value.product.net_price,
                                        'qty': value.quantity,
                                        'available_quantity': value.product.available_quantity,
                                        'is_recycled': value.product.is_recycled,
                                        'diameter': value.product.diameter,
                                        'aspect_ratio' : value.product.aspect_ratio,
                                        'width' : value.product.width,
                                        "net_price_with_rc": value.product.net_price_with_rc,
                                        "tyre_category" : value.product.tyre_category,
                                        "tyre_season" : value.product.tyre_season,
                                        "brand" : value.product.brand,
                                        "model" : value.product.model,
                                    })
                                    if(value.id && value.product && value.product.diameter 
                                        && value.product.diameter!=null
                                        && value.product.diameter.length > 0
                                        && parseInt(value.id)!='' && _.indexOf( rimSizes, parseInt(value.id)+":"+ value.product.diameter) == -1) {
                                            rimSizes.push(parseInt(value.id)+":"+ value.product.diameter)
                                    }
                                }
                                if(value.type==="shipping_charges") {
                                    response.data['shipping_charges'] = value.unit_price
                                }
                            });
                        }
                        if(response.data) {
                            commit('setCartDetails', response.data)
                        } else {
                            commit('setCartDetails', [])
                        }
                        commit('setCartProducts', products)
                        commit('setRimSizes', rimSizes)
                        resolve()
                    }).catch((e) => {
                        
                    }).finally(() => {
                        commit('setLoading', false)
                        TokenService.removeGuestToken()
                    })
            });
        }
        
    },
    async getAllCartProducts({commit, dispatch }) {
        let token = TokenService.getToken();
        commit('setLoading', true)
        const rimSizes = JSON.parse(JSON.stringify([]))
        if(token) {
            return new Promise((resolve, reject) => {
                ApiService.get('/customer/cart/items/all', [],
                { 'headers': { 'token': token} })
                .then(response => {
                    const products = []
                    if(response.data && response.data.id) {
                        commit('setCartId', response.data.id)
                    } else {
                        commit('setCartId', null)
                    }

                    commit('setPromocode', response.data.promo_code_name);

                    if(response.data 
                        && response.data.line_items 
                        && response.data.line_items.length > 0) {
                        _.forEach(response.data.line_items, function(value) {
                            if(value.type==="product") {
                                products.push({
                                    'cart_id':value.cart_id,
                                    'id':value.id,
                                    'type_id':value.type_id,
                                    'name':value.product.name,
                                    'brand_name':value.product.brand_name,
                                    'image': (value.product.images && value.product.images.length != 0 && value.product.images != null) ? value.product.images[0].image_base_path+value.product.images[0].path:'/images/no-data-found.png',
                                    'brand_image':(value.product.brand && value.product.brand.length != 0 && value.product.brand.image_path != null) ? value.product.brand.image_base_path+value.product.brand.image_path:'/images/nologo.png',
                                    'net_price': value.product.net_price,
                                    'qty': value.quantity,
                                    'available_quantity': value.product.available_quantity,
                                    'in_stock': value.product.in_stock,
                                    'is_recycled': value.product.is_recycled,
                                    'diameter': value.product.diameter,
                                    'aspect_ratio' : value.product.aspect_ratio,
                                    'width' : value.product.width,
                                    "net_price_with_rc": value.product.net_price_with_rc,
                                    "tyre_category" : value.product.tyre_category,
                                    "tyre_season" : value.product.tyre_season,
                                    "brand" : value.product.brand,
                                    "model" : value.product.model,
                                    "load_index" : value.product.load_index,
                                    "speed_index" : value.product.speed_index,
                                    "reinforced" : value.product.reinforced
                                })
                                if(value.id && value.product && value.product.diameter 
                                    && value.product.diameter!=null
                                    && value.product.diameter.length > 0
                                    && parseInt(value.id)!='' && _.indexOf( rimSizes, parseInt(value.id)+":"+ value.product.diameter) == -1) {
                                        rimSizes.push(parseInt(value.id)+":"+ value.product.diameter)
                                }
                            }
                            if(value.type==="shipping_charges") {
                                response.data['shipping_charges'] = value.unit_price
                            }
                        });
                    }
                    if(response.data) {
                        commit('setCartDetails', response.data)
                    } else {
                        commit('setCartDetails', [])
                    }
                    commit('setCartProducts', products)
                    commit('setRimSizes', rimSizes)
                    resolve()
                }).catch((e) => {
                    reject()
                }).finally(() => {
                    commit('setLoading', false)
                })
            });
        } else {
            let anonymousId = ''
            if(TokenService.getGuestToken()) {
                anonymousId = TokenService.getGuestToken()
            } else {
                TokenService.setGuestToken()
                anonymousId = TokenService.getGuestToken()
            }

            return new Promise((resolve, reject) => {
                ApiService.get('/anonymous/cart/items/all?anonymous_id='+anonymousId)
                .then(response => {
                    if(response.data && response.data.id) {
                        commit('setCartId', response.data.id)
                    } else {
                        commit('setCartId', null)
                    }
                    const products = []

                    commit('setPromocode', response.data.promo_code_name);

                    if(response.data 
                        && response.data.line_items 
                        && response.data.line_items.length > 0) {
                        _.forEach(response.data.line_items, function(value, key) {
                            if(value.type==="product") {
                                products.push({
                                    'cart_id':value.cart_id,
                                    'id':value.id,
                                    'type_id':value.type_id,
                                    'name':value.product.name,
                                    'brand_name':value.product.brand_name,
                                    'brand_image':(value.product.brand && value.product.brand.length != 0 && value.product.brand.image_path != null)
                                    ?value.product.brand.image_base_path+value.product.brand.image_path:'/images/nologo.png',
                                    'image': (value.product.images.length && value.product.images.length != 0)
                                    ? value.product.images[0].image_base_path+value.product.images[0].path:'/images/no-data-found.png',
                                    'net_price': value.product.net_price,
                                    'qty': value.quantity,
                                    'available_quantity': value.product.available_quantity,
                                    'in_stock': value.product.in_stock,
                                    'is_recycled': value.product.is_recycled,
                                    'diameter': value.product.diameter,
                                    'aspect_ratio' : value.product.aspect_ratio,
                                    'width' : value.product.width,
                                    "net_price_with_rc": value.product.net_price_with_rc,
                                    "vehicle_type" : value.product.car_type,
                                    "tyre_category" : value.product.tyre_category,
                                    "tyre_season" : value.product.tyre_season,
                                    "brand" : value.product.brand,
                                    "model" : value.product.model,
                                    "load_index" : value.product.load_index,
                                    "speed_index" : value.product.speed_index,
                                    "reinforced" : value.product.reinforced
                                });

                                if(value.id && value.product && value.product.diameter 
                                    && value.product.diameter!=null
                                    && value.product.diameter.length > 0) {
                                    if( parseInt(value.id)!='' && _.indexOf( rimSizes, parseInt(value.id)+":"+ value.product.diameter) == -1) {
                                        rimSizes.push(parseInt(value.id)+":"+ value.product.diameter)
                                    }
                                }
                            }
                            if(value.type==="shipping_charges") {
                                response.data['shipping_charges'] = value.unit_price
                            }
                        });
                    }
                    if(response.data) {
                        commit('setCartDetails', response.data)
                    } else {
                        commit('setCartDetails', [])
                    }
                    commit('setCartProducts', products)
                    commit('setRimSizes', rimSizes)
                    resolve()
                }).catch((e) => {
                    reject()
                }).finally(() => {
                    commit('setLoading', false)
                })
            });
        }
    },
    addInstallationShippingCharges({commit, dispatch }) {
        let token = TokenService.getToken();
        commit('setPromoLoading', true)
        if(token) {
            return new Promise((resolve, reject) => {
                ApiService.post('/customer/cart/services/add-shipping-charge', [],
                { 'headers': { 'token': token} })
                .then(response => {
                    let cartDetailsArr = state.cartDetails;
                    cartDetailsArr['shipping_charges'] = response.data.unit_price;
                    commit('setCartDetails', cartDetailsArr)
                    resolve()
                }).catch((e) => {
                    reject()
                }).finally(() => {
                    commit('setPromoLoading', false)
                })
            });
        } else {
            let anonymousId = ''
            if(TokenService.getGuestToken()) {
                anonymousId = TokenService.getGuestToken()
            } else {
                TokenService.setGuestToken()
                anonymousId = TokenService.getGuestToken()
            }
            const params = {
                'anonymous_id': anonymousId
            }
            
            return new Promise((resolve, reject) => {
                ApiService.post('/anonymous/cart/services/add-shipping-charge', {'anonymous_id': anonymousId})
                    .then(response => {
                        let cartDetailsArr = state.cartDetails;
                        cartDetailsArr['shipping_charges'] = response.data.unit_price;
                        commit('setCartDetails', cartDetailsArr)
                    resolve()
                }).catch((e) => {
                    reject()
                }).finally(() => {
                    commit('setPromoLoading', false)
                })
            });
        }
    },
    async removeInstallationShippingCharges({commit, dispatch }) {
        let token = TokenService.getToken();
        commit('setPromoLoading', true)
        if(token) {
            return new Promise((resolve, reject) => {
                ApiService.post('/customer/cart/services/remove-shipping-charge', [],
                { 'headers': { 'token': token} })
                .then(response => {
                    let cartDetailsArr = state.cartDetails;
                    cartDetailsArr['shipping_charges'] = response.data.unit_price;
                    commit('setCartDetails', cartDetailsArr)
                    resolve()
                }).catch((e) => {
                    reject()
                }).finally(() => {
                    commit('setPromoLoading', false)
                })
            });
        } else {
            let anonymousId = ''
            if(TokenService.getGuestToken()) {
                anonymousId = TokenService.getGuestToken()
            } else {
                TokenService.setGuestToken()
                anonymousId = TokenService.getGuestToken()
            }
            const params = {
                'anonymous_id': anonymousId
            }
            commit('setPromoLoading', true)
            return new Promise((resolve, reject) => {
                ApiService.post('/anonymous/cart/services/remove-shipping-charge', {'anonymous_id': anonymousId})
                    .then(response => {
                        let cartDetailsArr = state.cartDetails;
                        cartDetailsArr['shipping_charges'] = response.data.unit_price;
                        commit('setCartDetails', cartDetailsArr)
                    resolve()
                }).catch((e) => {
                    reject()
                }).finally(() => {
                    commit('setPromoLoading', false)
                })
            });
        }
    },
    async addProduct({commit, dispatch }, product) {
        const token = TokenService.getToken()
        commit('qtyLoading', true);
        return new Promise((resolve, reject) => {
            const productIndex = _.findIndex(state.cartProducts, function(cartProduct)
                { 
                    return cartProduct.name == product.name; 
                }
            );
            
            if(productIndex > -1) {
                state.cartProducts[productIndex]['qty'] = product.qty
            }
            
            let params = {}
            params = {
                'type': 'product',
                'type_id': product.type_id,
                'quantity': product.qty,
            };
            
            if(token) {
                ApiService.post('/customer/cart/item/insert', params,
                { 'headers': { 'token': token} })
                .then(response => {
                    if(response.data.errors) {
                        product.error = response.data.errors
                        reject()
                    } else {

                        if(productIndex === -1) {
                            // product.qty = 4
                            // commit('setProduct', product);
                        } else {
                            let qty = parseInt(state.cartProducts[productIndex]['qty'])
                            // state.cartProducts[productIndex]['qty'] = !isNaN(qty) ? qty + 1: 1;
                            state.cartProducts[productIndex]['qty'] = params.quantity;
                            commit('updateProduct', state.cartProducts[productIndex])
                        }
                        resolve(response)
                    }
                }).catch(errors => {
                    reject(errors)
                }).finally(() => {
                    commit('qtyLoading', false);
                })

            } else {
                let anonymousId = ''
                if(TokenService.getGuestToken()) {
                    anonymousId = TokenService.getGuestToken()
                } else {
                    TokenService.setGuestToken()
                    anonymousId = TokenService.getGuestToken() 
                }
                params.anonymous_id = anonymousId
                
                ApiService.post('/anonymous/cart/item/insert', params)
                .then(response => {
                    if(response.data.errors) {
                        product.error = response.data.errors
                        reject()
                    } else {
                        if(productIndex === -1) {
                            commit('setProduct', product);
                        } else {
                            let qty = parseInt(state.cartProducts[productIndex]['qty'])
                            state.cartProducts[productIndex]['qty'] = !isNaN(qty) ? qty + 1: 1;
                            commit('updateProduct', state.cartProducts[productIndex])
                        }
                        resolve(response)
                    }
                }).catch(errors => {
                    reject(errors)
                }).finally(() => {
                    commit('qtyLoading', false);
                })
            }
            
            // dispatch('getAllCartProducts');

        })
    },
    updateQuantity({commit}, product) {
        const productToUpdate = state.cartProducts[product.index];
        if(product.action=='add') {
            productToUpdate.qty = productToUpdate.qty + 1;
            commit('updateProductQuantity', productToUpdate);
        }
        if(product.action=='remove') { 
            productToUpdate.qty = productToUpdate.qty - 1;
            if(productToUpdate.qty == 0) {
                this.removeCartProduct(product.index)
            } else {
                commit('updateProductQuantity', productToUpdate);
            } 
        }
    },
    async removeCartProduct({commit}, product) {
        const token = TokenService.getToken()
        commit('setLoading', true)
        return new Promise((resolve, reject) => {
            if(token) {
                const formdata = {
                    'cart_id': product.cart_id,
                    'cart_line_item_id': product.id,
                }
                ApiService.post('/customer/cart/line-item/remove', formdata, { 'headers': { 'token': token} }).then(response => {
                    const productIndex = _.findIndex(state.cartProducts, function(cartProduct)
                        { 
                            return cartProduct.id == product.id; 
                        }
                    );
                    commit('removeProduct', productIndex);
                    commit('removeProductRimSize', productIndex)
                    resolve()
                }).catch((e) => {
                    console.log(e)
                    reject()
                }).finally(() => {
                    commit('setLoading', false)
                    
                })
            } else {
                let anonymousId = ''
                if(TokenService.getGuestToken()) {
                    anonymousId = TokenService.getGuestToken()
                } else {
                    TokenService.setGuestToken()
                    anonymousId = TokenService.getGuestToken()
                }
                const formdata = {
                    'cart_id': product.cart_id,
                    'cart_line_item_id': product.id,
                    'anonymous_id': anonymousId
                }
                ApiService.post('/anonymous/cart/line-item/remove', formdata).then(response => {
                    const productIndex = _.findIndex(state.cartProducts, function(cartProduct)
                        { 
                            return cartProduct.id == product.id; 
                        }
                    );
                    commit('removeProduct', productIndex);
                    commit('removeProductRimSize', product.id)
                    resolve()
                }).catch((e) => {
                    console.log(e)
                    reject()
                }).finally(() => {
                    commit('setLoading', false)
                })
            }
        })
    },
    removeAllCartServices({commit}) {
        let details = state.cartDetails
        const token = TokenService.getToken()
        commit('setLoading', true)
        return new Promise((resolve, reject) => {
            if(token) {
                const formdata = {
                    'cart_id': details.id
                }
                ApiService.post('/customer/cart/services/remove', formdata,
                { 'headers': { 'token': token} })
                .then(response => {
                    commit('setRimSizes', [])
                    resolve()
                }).catch((e) => {
                    reject()
                }).finally(() => {
                    commit('setLoading', false)
                })
            } else {
                let anonymousId = ''
                if(TokenService.getGuestToken()) {
                    anonymousId = TokenService.getGuestToken()
                } else {
                    TokenService.setGuestToken()
                    anonymousId = TokenService.getGuestToken()
                }
                const formdata = {
                    'cart_id': details.id,
                    'anonymous_id': anonymousId
                }
                ApiService.post('/anonymous/cart/services/remove', formdata)
                .then(response => {
                    commit('setRimSizes', [])
                    resolve()
                }).catch((e) => {
                    reject()
                }).finally(() => {
                    commit('setLoading', false)
                })
            }
        })
    },
    getAdditionalServices({commit}) {
        commit('setServicesLoading', true)
        return new Promise((resolve, reject) => {
            ApiService.get('/service')
            .then(response => {                
                commit('setAdditionalServices', HashMake.decrypt(response.data.data))
            }).catch((e) => {
                
            }).finally(() => {
                commit('setServicesLoading', false);
            })
        });
    },
    applyPromocode({commit}, params) {
        commit('setPromoLoading', true)
        commit('resetErrors')
        const token = TokenService.getToken()
        return new Promise((resolve, reject) => {
            if(token) {
                ApiService.post('/customer/cart/promo-code/apply', params,
                { 'headers': { 'token': token} })
                .then(response => {
                    commit('setPromocode', params.promocode);
                    resolve()
                }).catch((e) => {
                    if (e.response 
                        && e.response.data
                        && e.response.data.errors) {
                        commit('setPromocodeErrors', e.response.data.errors)
                    }
                    reject()
                }).finally(() => {
                    commit('setPromoLoading', false);
                })
            } else {
                let anonymousId = ''
                if(TokenService.getGuestToken()) {
                    anonymousId = TokenService.getGuestToken()
                } else {
                    TokenService.setGuestToken()
                    anonymousId = TokenService.getGuestToken()
                }
                ApiService.post('/anonymous/cart/promo-code/apply?anonymous_id='+anonymousId, params)
                .then(response => {
                    commit('setPromocode', params.promocode);
                    resolve()
                }).catch((e) => {                    
                    if (e.response 
                        && e.response.data
                        && e.response.data.errors) {
                        commit('setPromocodeErrors', e.response.data.errors)
                    }
                    reject()
                }).finally(() => {
                    commit('setPromoLoading', false);
                })
            }
        })
    },
    removePromocode({commit}) {
        commit('setPromoLoading', true)
        const token = TokenService.getToken()
        return new Promise((resolve, reject) => {
            if(token) {
                ApiService.post('/customer/cart/promo-code/remove', [],
                { 'headers': { 'token': token} })
                .then(response => {
                    commit('resetPromocode')
                    resolve()
                }).catch((e) => {
                    reject()
                }).finally(() => {
                    commit('setPromoLoading', false);
                })
            } else {
                let anonymousId = ''
                if(TokenService.getGuestToken()) {
                    anonymousId = TokenService.getGuestToken()
                } else {
                    TokenService.setGuestToken()
                    anonymousId = TokenService.getGuestToken()
                }
                ApiService.post('/anonymous/cart/promo-code/remove?anonymous_id='+anonymousId, [],
                { 'headers': { 'token': token} })
                .then(response => {
                    commit('resetPromocode')
                    resolve()
                }).catch((e) => {
                    reject()
                }).finally(() => {
                    commit('setPromoLoading', false);
                })
            }
        });
    },
    currentProduct({commit}, product) {
        commit('currentProduct', product);
    },
    showOrHiddenModal({commit}) {
        commit('SHOW_MODAL');
    },
    showOrHiddenPopupCart({commit}) {
        commit('SHOW_POPUP_CART');
    },
    clearCartProducts({commit}) {
        commit('setLoading', true)
        commit('setCartProducts', [])
        commit('setLoading', false)
    },
    settingPromocode({commit}, promocode) {
        commit('setPromocode', promocode)
    },
    resetPromocode({commit}) {
        commit('setPromocode', null)
    },
    resetPromocodeError({commit}) {
        commit('resetErrors')
    },
    async updatePaytrailStatus({commit}, orderId) {

        const token = TokenService.getToken()
        commit('setLoading', true)
        return new Promise((resolve, reject) => {
                const formdata = {
                    'order_id': orderId,
                    'payment_status': "manual_fail"
                }
                ApiService.post('/order/paytrail-status/update', formdata).then(response => {
                    resolve()
                }).catch((e) => {
                    console.log(e)
                    reject()
                }).finally(() => {
                    commit('setLoading', false)
                })
            
        })
    },
    updateCartShippingAddressType({commit}, addressType) {
        commit('setCartShippingAddressType', addressType)
    },
    setCartId({commit}, cartId) {
        commit('setCartId', cartId);
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}